/* eslint-disable no-underscore-dangle */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import Modal from '@tencent/dui/lib/components/Modal';
import Select from '@tencent/dui/lib/components/Select';
import Divider from '@tencent/dui/lib/components/Divider';
import { Application } from '@tencent/alloy-renderer';
import { BrowserTarget } from '@tencent/alloy-renderer-browser';
import Styles from './styles.css';
import {
    defaultMultiVal,
    defaultFixedVal,
    getPreviewParagraphList,
} from './data';
import {
    LineHeightType,
} from '../paragraph-manager.interface';
import i18n from '@i18next/i18n';
import TabstopModal from './tabstop-modal';
import { NumberInput } from '@tencent/wb-ext-form';
import Unit from './components/unit';
import { MAX_CM, MIN_CM, MAX_PT, MIN_PT, STEP_CM, STEP_PT, MAX_MULTIPLE, STEP_MULTIPLE } from './const';
import { handleParagraphMoreDialogTdw, onClickTabstopModalTdw } from './tdw-util';
import { PPTEditorStateType } from '../../../../../domain/ui-model/constant/edit-state-type';
import ParagraphManager from '@src/slide/application/service/paragraph-manager/core/paragraph-manager';
import {
    IUserPriviledgeService,
} from '@src/slide/application/service/user-priviledge-service/user-priviledge-service.interface';
import { ITipsManager } from '@src/slide/application/service/tips-manager/core/tips-manager.interface';
import {
    IEditorServices,
} from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/components/text-editor/interface/editor-service.interface';
import {
    AlignType,
} from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/components/text-editor/editor-controller/editor-operations/constant';
import { TextEditor } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/components/text-editor';

const PREVIEW_WRAPPER_WIDTH = 374;
const PREVIEW_WRAPPER_HEIGHT = 102;

const textRect = {
    left: 0,
    top: 0,
    width: PREVIEW_WRAPPER_WIDTH,
    height: PREVIEW_WRAPPER_HEIGHT,
};

function isInvalid(val) {
    return val === null || val === undefined || isNaN(val);
}

function getInitialParagraphProps() {
    return {
        lineHeightType: '',
        alignmentType: '',
        marginLeft: undefined,
        textIndent: undefined,
        textIndentType: '',
        spaceBefore: undefined,
        spaceAfter: undefined,
        tabList: undefined,
        tabSize: undefined,
    };
}


interface IParagraphMoreDialogProps {
    userPriviledgeService: IUserPriviledgeService;
    tipsManager: ITipsManager;
    isTabstopModalVisible: boolean;
    editorServices: IEditorServices;
}

@observer
class ParagraphMoreDialog extends Component<IParagraphMoreDialogProps, any> {
    public static propTypes = {
        userPriviledgeService: PropTypes.object,
        tipsManager: PropTypes.object,
        isTabstopModalVisible: PropTypes.bool,
    };
    public static wrapperDiv: HTMLDivElement | undefined;
    /**
     * @type {Application | null}
     */
    public static previewRendererApplication: Application | null = null;
    private static paragraphManager: ParagraphManager;

    public static setParagraphManager(paragraphManager: ParagraphManager) {
        ParagraphMoreDialog.paragraphManager = paragraphManager;
    }

    public static show(config) {
        this.wrapperDiv = document.createElement('div');
        // eslint-disable-next-line react/no-render-return-value
        return ReactDOM.render(<ParagraphMoreDialog {...config} />, this.wrapperDiv);
    }

    public static remove() {
        ParagraphMoreDialog.previewRendererApplication?.dispose();
        ParagraphMoreDialog.previewRendererApplication = null;
        ReactDOM.unmountComponentAtNode(this.wrapperDiv as Element);
    }

    private initMultiVal;
    private initFixedVal;
    private previewRef;
    private previewEditor;
    private initLineHeightType;
    private initTabList;

    public constructor(props) {
        super(props);

        this.initMultiVal = defaultMultiVal;
        this.initFixedVal = defaultMultiVal;
        const initStates = this.initStatesFromParagraphManager();

        const initialParaProps = getInitialParagraphProps();
        this.state = {
            multiVal: defaultMultiVal,
            fixedVal: defaultFixedVal,
            ...initialParaProps,
            ...initStates,
            paragraphList: getPreviewParagraphList({ ...initialParaProps, ...initStates }),
            isTabstopModalVisible: !!props.isTabstopModalVisible,
        };
        this.previewRef = null;
        this.previewEditor = null;
    }

    public setTabstopModalVisible = (visible) => {
        onClickTabstopModalTdw();
        this.setState({ isTabstopModalVisible: visible });
    };

    public componentDidMount() {
        this.initPreview();
    }

    public get lineHeight() {
        return this.getLineHeight(this.state.lineHeightType, this.state.multiVal, this.state.fixedVal);
    }

    public render() {
        const lineHeightVal = this.state.lineHeightType === LineHeightType.Multi
            ? this.state.multiVal : this.state.fixedVal;
        return (
            <>
                <Modal
                    className={Styles['para-panel-wrapper']}
                    maskClosable={false}
                    title={i18n.t('段落')}
                    visible={true}
                    okText={i18n.t('应用')}
                    cancelText={i18n.t('取消')}
                    onCancel={this.hideModal.bind(this, { resumeEditorSelection: true })}
                    onClose={this.hideModal.bind(this, { resumeEditorSelection: true })}
                    onOk={this.handleModalOK}
                    style={{
                        width: 422,
                    }}
                    action={`${i18n.t('制表符')}...`}
                    onClickAction={() => this.setTabstopModalVisible(true)}
                >
                    <div>
                        <div>
                            <div>{`${i18n.t('常规')}${i18n.t('：')}`}</div>
                            <div className={Styles['para-panel-item']}>
                                <div className={Styles['para-panel-item-title']} style={{ marginLeft: '14px' }}>{`${i18n.t('对齐')}${i18n.t('：')}`}</div>
                                <Select
                                    value={this.state.alignmentType}
                                    onChange={this.handleAlignmentTypeChange}
                                    style={{
                                        width: 110,
                                        height: 28,
                                    }}
                                >
                                    <Select.Option value={AlignType.HORIZONTAL_LEFT}>{i18n.t('向左对齐')}</Select.Option>
                                    <Select.Option value={AlignType.HORIZONTAL_CENTER}>{i18n.t('居中对齐')}</Select.Option>
                                    <Select.Option value={AlignType.HORIZONTAL_RIGHT}>{i18n.t('向右对齐')}</Select.Option>
                                    <Select.Option value={AlignType.HORIZONTAL_JUSTIFY}>{i18n.t('两端对齐')}</Select.Option>
                                    <Select.Option value={AlignType.HORIZONTAL_DISTRIBUTE}>{i18n.t('分散对齐')}</Select.Option>
                                </Select>
                            </div>
                        </div>
                        <Divider style={{ margin: '15px 0' }} />
                        <div className={Styles['para-panel']}>
                            <div>{`${i18n.t('缩进')}${i18n.t('：')}`}</div>
                            <div className={Styles['para-panel-item']} style={{ marginLeft: '14px' }}>
                                <div className={Styles['para-panel-item-title']}>{`${i18n.t('文本之前')}${i18n.t('：')}`}</div>
                                <NumberInput
                                    value={this.state.marginLeft}
                                    step={STEP_CM}
                                    defaultValue={0}
                                    allowDecimal
                                    max={MAX_CM}
                                    min={MIN_CM}
                                    toFixed={2}
                                    onChange={this.handleMarginLeftChange}
                                    style={{
                                        width: 80,
                                    }}
                                >
                                </NumberInput>
                                <Unit unitStr={i18n.t('厘米')} />
                            </div>
                        </div>
                        <div style={{ marginTop: '10px', width: '10px' }}></div>
                        <div className={Styles['para-panel']}>
                            <div className={Styles['para-panel-item']} style={{ marginLeft: '14px' }}>
                                <div className={Styles['para-panel-item-title']}>{`${i18n.t('特殊格式')}${i18n.t('：')}`}</div>
                                <Select
                                    onChange={(textIndentType) => {
                                        if (textIndentType === this.state.textIndentType) {
                                            return;
                                        }
                                        let { textIndent } = this.state;
                                        if (textIndentType === 'none') {
                                            textIndent = 0;
                                        } else if (this.state.textIndentType === 'none') {
                                            textIndent = 1.27;
                                        }
                                        this.setState({ textIndentType, textIndent }, this.updatePreview);
                                    }}
                                    style={{
                                        width: 110,
                                        height: 28,
                                    }}
                                    value={this.state.textIndentType}
                                >
                                    <Select.Option value="none">{`${i18n.t('（')}${i18n.t('无')}${i18n.t('）')}`}</Select.Option>
                                    <Select.Option value="hanging">{i18n.t('悬挂')}</Select.Option>
                                    <Select.Option value="first-line">{i18n.t('第一行')}</Select.Option>
                                </Select>
                                <div className={`${Styles['para-panel-item-title']} ${Styles['para-panel-item-sub-title']}`}>{`${i18n.t('数值')}${i18n.t('：')}`}</div>
                                <NumberInput
                                    value={this.state.textIndent}
                                    defaultValue={0}
                                    allowDecimal
                                    disabled={this.state.textIndentType === 'none' || this.state.textIndentType === ''}
                                    step={STEP_CM}
                                    max={MAX_CM}
                                    min={MIN_CM}
                                    toFixed={2}
                                    onChange={this.handleTextIndentChange}
                                    style={{
                                        width: 80,
                                    }}
                                >
                                </NumberInput>
                                <Unit unitStr={i18n.t('厘米')} />
                            </div>
                        </div>
                        <Divider style={{ margin: '15px 0' }} />
                        <div className={Styles['para-panel']}>
                            <div>{`${i18n.t('间距')}${i18n.t('：')}`}</div>
                            <div className={Styles['para-panel-item']} style={{ marginLeft: '14px' }}>
                                <div className={Styles['para-panel-item-title']}>{`${i18n.t('段前')}${i18n.t('：')}`}</div>
                                <NumberInput
                                    value={this.state.spaceBefore}
                                    defaultValue={0}
                                    allowDecimal
                                    step={STEP_PT}
                                    max={MAX_PT}
                                    min={MIN_PT}
                                    toFixed={2}
                                    onChange={this.handleSpaceBeforeChange}
                                    style={{
                                        width: 80,
                                    }}
                                >
                                </NumberInput>
                                <Unit unitStr={i18n.t('磅')} style={{ marginRight: 14 }} />
                            </div>
                            <div className={Styles['para-panel-item']}>
                                <div className={`${Styles['para-panel-item-title']} ${Styles['para-panel-item-sub-title']}`}>{`${i18n.t('段后')}${i18n.t('：')}`}</div>
                                <NumberInput
                                    value={this.state.spaceAfter}
                                    defaultValue={0}
                                    allowDecimal
                                    step={STEP_PT}
                                    max={MAX_PT}
                                    min={MIN_PT}
                                    toFixed={2}
                                    onChange={this.handleSpaceAfterChange}
                                    style={{
                                        width: 80,
                                    }}
                                >
                                </NumberInput>
                                <Unit unitStr={i18n.t('磅')} />
                            </div>
                        </div>
                        <div style={{ marginTop: '10px', width: '10px' }}></div>
                        <div className={Styles['para-panel']} style={{ marginLeft: '14px' }}>
                            <div className={Styles['para-panel-item']}>
                                <div className={Styles['para-panel-item-title']}>{`${i18n.t('行间距')}${i18n.t('：')}`}</div>
                                <Select
                                    value={this.state.lineHeightType}
                                    onChange={this.handleLineHeightTypeChange}
                                    style={{
                                        width: 110,
                                        height: 28,
                                    }}
                                >
                                    <Select.Option value={LineHeightType.Multi}>{i18n.t('多倍行距')}</Select.Option>
                                    <Select.Option value={LineHeightType.Fixed}>{i18n.t('固定值')}</Select.Option>
                                </Select>
                            </div>
                            <div className={Styles['para-panel-item']}>
                                <div className={`${Styles['para-panel-item-title']} ${Styles['para-panel-item-sub-title']}`}>{`${i18n.t('数值')}${i18n.t('：')}`}</div>
                                <NumberInput
                                    value={this.state.lineHeightType === '' ? null : lineHeightVal}
                                    defaultValue={0}
                                    allowDecimal
                                    disabled={this.state.lineHeightType === ''}
                                    step={(this.state.lineHeightType === LineHeightType.Multi) ? STEP_MULTIPLE : 1}
                                    max={this.state.lineHeightType === LineHeightType.Multi ? MAX_MULTIPLE : MAX_PT}
                                    min={this.state.lineHeightType === LineHeightType.Multi ? 0.25 : 0.7}
                                    toFixed={2}
                                    onChange={this.handleLineHeightChange}
                                    style={{
                                        width: 80,
                                    }}
                                >
                                </NumberInput>
                                <Unit unitStr={
                                    (this.state.lineHeightType === LineHeightType.Multi && i18n.t('倍')) || i18n.t('磅')
                                } />
                            </div>
                        </div>
                        <div style={{ marginTop: 26 }}>
                            <div>{i18n.t('预览')}</div>
                            <div className={Styles['para-preview-wrapper']}>
                                <canvas ref={canvasRef => this.previewRef = canvasRef} />
                            </div>
                        </div>
                    </div>
                </Modal>
                <TabstopModal
                    isVisible={this.state.isTabstopModalVisible}
                    setVisible={this.setTabstopModalVisible}
                    tabList={this.state.tabList}
                    tabSize={this.state.tabSize}
                    setTabList={tabList => this.setState({ tabList })}
                    setTabSize={tabSize => this.setState({ tabSize })}
                />
            </>
        );
    }

    // eslint-disable-next-line complexity
    private initStatesFromParagraphManager() {
        const initialStates: any = {};
        const { alignmentType } = ParagraphMoreDialog.paragraphManager;
        if (typeof alignmentType === 'string') {
            initialStates.alignmentType = alignmentType;
        }

        const { lineHeight, lineHeightType } = ParagraphMoreDialog.paragraphManager;
        if (lineHeightType !== undefined) {
            initialStates.lineHeightType = lineHeightType;
            this.initLineHeightType = lineHeightType;
            if (lineHeight !== undefined) {
                initialStates.lineHeight = lineHeight;
                if (lineHeightType === LineHeightType.Multi) {
                    initialStates.multiVal = lineHeight;
                    this.initMultiVal = lineHeight;
                } else {
                    initialStates.fixedVal = lineHeight;
                    this.initFixedVal = lineHeight;
                }
            }
        }

        const { marginLeft } = ParagraphMoreDialog.paragraphManager;
        if (!isInvalid(marginLeft)) {
            initialStates.marginLeft = marginLeft;
        }

        const { textIndent } = ParagraphMoreDialog.paragraphManager as { textIndent: number };
        if (!isInvalid(textIndent)) {
            let textIndentType = 'none';
            if (textIndent > 0) {
                textIndentType = 'first-line';
            } else if (textIndent < 0) {
                textIndentType = 'hanging';
            }
            initialStates.textIndent = Math.abs(textIndent);
            initialStates.textIndentType = textIndentType;
        }

        const { spaceBefore } = ParagraphMoreDialog.paragraphManager;
        if (!isInvalid(spaceBefore)) {
            initialStates.spaceBefore = spaceBefore;
        }

        const { spaceAfter } = ParagraphMoreDialog.paragraphManager;
        if (!isInvalid(spaceAfter)) {
            initialStates.spaceAfter = spaceAfter;
        }

        const { tabList } = ParagraphMoreDialog.paragraphManager;
        if (tabList !== undefined) {
            this.initTabList = [...tabList];
            initialStates.tabList = [...tabList];
        }

        const { tabSize } = ParagraphMoreDialog.paragraphManager;
        if (!isInvalid(tabSize)) {
            initialStates.tabSize = tabSize;
        }

        return initialStates;
    }

    private getLineHeight(lineHeightType, multiVal, fixedVal) {
        return (lineHeightType === LineHeightType.Multi && multiVal) || fixedVal;
    }

    private initPreview = () => {
        const app = new Application(new BrowserTarget(), { native: this.previewRef, interactive: false });
        ParagraphMoreDialog.previewRendererApplication = app;
        app.resolution = Math.ceil(window.devicePixelRatio);
        app.width = PREVIEW_WRAPPER_WIDTH;
        app.height = PREVIEW_WRAPPER_HEIGHT;
        const editor = new TextEditor({
            paragraphList: this.state.paragraphList,
            selectable: false,
            editable: false,
            modelKey: 'paragraph-dialog-preview',
            textRect,
        }, this.props.editorServices);
        this.previewEditor = editor;
        app.stage.addChild(editor.editorContainer);
        app.requestRender();
    };

    private hideModal = () => {
        ParagraphMoreDialog.paragraphManager.hideParagraph();
    };

    private judgeEditableLock = () => {
        if (this.props.userPriviledgeService.pptEditorState > PPTEditorStateType.EDITABLE) {
            this.props.tipsManager?.showCannotEditTips();
            return false;
        }
        return true;
    };

    private handleModalOK = (event) => {
        // 根据 dui 文档，没有 event 参数表示是 enter 按键触发。
        // 按键触发保存时由于不会触发 input 的 blur，也就无法触发 input 值的合法化校验，导致非法参数被保存，这里直接禁掉 enter 保存
        if (!event) {
            return;
        }
        if (!this.judgeEditableLock()) return;
        let updateProps = {
            alignmentType: this.state.alignmentType,
            lineHeight: this.lineHeight,
            lineHeightType: this.state.lineHeightType,
            marginLeft: this.state.marginLeft,
            textIndent: this.state.textIndentType === 'hanging' ? -this.state.textIndent : this.state.textIndent,
            spaceBefore: this.state.spaceBefore,
            spaceAfter: this.state.spaceAfter,
            tabList: this.state.tabList,
            tabSize: this.state.tabSize,
        };
        updateProps = this.filterUpdatePropsIfUnchanged(updateProps);
        handleParagraphMoreDialogTdw(updateProps);
        ParagraphMoreDialog.paragraphManager.updateUI(updateProps);
        this.hideModal();
    };

    /* 如果点击应用时值和初始值一样，则跳过设置 */
    private filterUpdatePropsIfUnchanged(updateProps) {
        const newUpdateProps = { ...updateProps };
        Object.entries(updateProps).forEach(([key, value]) => {
            const initKey = `init${key.charAt(0).toUpperCase()}${key.slice(1)}`;
            if (initKey === 'initTabList' && Array.isArray(updateProps[key])) {
                const initialTabList = this[initKey];
                // tabList 为数组，需要单独做 equal 判断
                const isTabListUnchanged = initialTabList.length === updateProps[key].length
                    && updateProps[key].every((tabstop, index) => (tabstop.position === initialTabList[index].position
                            && tabstop.alignment === initialTabList[index].alignment));
                isTabListUnchanged && delete newUpdateProps[key];
            } else if (key.toLowerCase().includes('lineheight')) {
                // lineHeight 为复合属性，单独处理
                return;
            } else if (this[initKey] === value) {
                delete newUpdateProps[key];
            }
        });
        if (this.getLineHeight(
            this.state.lineHeightType,
            this.state.multiVal,
            this.state.fixedVal,
        ) === this.getLineHeight(
            this.initLineHeightType,
            this.initMultiVal,
            this.initFixedVal,
        )) {
            delete newUpdateProps.lineHeight;
            delete newUpdateProps.lineHeightType;
        }
        return newUpdateProps;
    }

    private handleLineHeightTypeChange = (lineHeightType) => {
        this.setState({ lineHeightType }, this.updatePreview);
    };

    private handleMarginLeftChange = (marginLeft) => {
        const marginLeftFloat = parseFloat(marginLeft);
        if (isNaN(marginLeftFloat)) {
            return;
        }
        this.setState({ marginLeft: marginLeftFloat }, this.updatePreview);
    };

    private handleTextIndentChange = (textIndent) => {
        const textIndentFloat = parseFloat(textIndent);
        if (isNaN(textIndentFloat)) {
            return;
        }
        this.setState({ textIndent: textIndentFloat }, this.updatePreview);
    };

    private handleSpaceBeforeChange = (spaceBefore) => {
        spaceBefore = parseFloat(spaceBefore);
        if (isNaN(spaceBefore)) {
            return;
        }
        this.setState({ spaceBefore }, this.updatePreview);
    };

    private handleSpaceAfterChange = (spaceAfter) => {
        spaceAfter = parseFloat(spaceAfter);
        if (isNaN(spaceAfter)) {
            return;
        }
        this.setState({ spaceAfter }, this.updatePreview);
    };

    private handleAlignmentTypeChange = (alignmentType) => {
        this.setState({ alignmentType }, this.updatePreview);
    };

    private handleLineHeightChange = (lineHeightStr) => {
        const val = parseFloat(lineHeightStr);
        if (isNaN(val)) {
            return;
        }
        if (this.state.lineHeightType === LineHeightType.Multi) {
            this.setState({ multiVal: this.fixLineHeight(val) }, this.updatePreview);
        } else {
            this.setState({ fixedVal: this.fixLineHeight(val) }, this.updatePreview);
        }
    };

    private fixLineHeight = (value) => {
        function fix(val, count) {
            const v = Number(val);
            if (isNaN(v)) return val;
            return Math.floor(v * (10 ** count)) / (10 ** count);
        }

        if (value === '') return value;

        let v = value;
        if (this.state.lineHeightType === LineHeightType.Multi) {
            if (!/^\d{1,}(\.\d{0,2})?$/.test(v)) {
                v = fix(v, 2);
            }
        } else if (!/^\d{1,}(\.\d{0,1})?$/.test(v)) {
            v = fix(v, 1);
        }

        return v;
    };

    private updatePreview = () => {
        const newParagraphList = getPreviewParagraphList({
            ...this.state,
            lineHeight: this.lineHeight,
        });
        this.previewEditor?.updateEditorProps({
            paragraphList: newParagraphList,
            shouldUpdate: true,
            textRect,
        });
        this.setState({
            paragraphList: newParagraphList,
        });
    };
}

export default ParagraphMoreDialog;
